// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Premaknjeno: ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Dejanje ' + p['label'] + ' je dokončano',
  accButtonProgressStatus: (p: { label: string }) => 'Dejanje ' + p['label'] + ' je v teku',
  accColorPalette: () => 'Barvna paleta',
  accColorSwatch: () => 'Barvna paleta',
  accCommandKey: () => 'Ukaz',
  accContextMenuLabel: () => 'dejanja',
  accControlKey: () => 'Zapri',
  accPositionAfter: () => 'po',
  accPositionBefore: () => 'pred',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Pritisnite in pridržite tipko ' +
    p['keyPressed'] +
    ' ter tipki Shift, nato pa spremenite vrstni red s puščičnima tipkama.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Vnesite celoten datum, kot je ta: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Vnesite mesec in leto, kot sledi: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Oznaka',
  chart_labelGroup: () => 'Skupina',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Vrednost',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Izberite vrednost.',
  checkbox_helpForCheckbox: () => 'Pomoč za potrditveno polje',
  checkbox_requiredMessageDetail: () => 'Izberite vrednost.',
  checkbox_selected: () => 'Potrditveno polje je označeno',
  checkbox_unselected: () => 'Potrditveno polje ni označeno',
  close: () => 'Zapri',
  collection_apply: () => 'Dodeli',
  collection_cancel: () => 'Prekliči',
  collection_loaded: () => 'Naloženo',
  collection_loading: () => 'Nalaganje',
  collection_noData: () => 'Ni podatkov za prikaz.',
  collection_pixels: () => 'piksli',
  collection_resizeColumnDialog: () => 'Sprememba velikosti stolpca',
  collection_resizeColumnMenu: () => 'Spremeni velikost stolpca...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Vnesite število med ' + p['MIN'] + ' in ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Izbira vseh vrstic',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Izbira vrstice ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Naraščajoče',
  collection_sortColumnMenu: () => 'Razvrsti stolpec',
  collection_sortDescendingSubMenu: () => 'Padajoče',
  collection_sortDisabled: () => 'Ni razvrstljivo',
  collection_sortEnabled: () => 'Razvrstljivo',
  collection_width: () => 'Širina',
  colorPicker_label: () => 'Izbirnik barve',
  confirmation: () => 'Potrditev',
  datePicker_currentDate: () => 'Trenutni datum',
  datePicker_goToToday: () => 'Pojdi na danes',
  datePicker_label: () => 'Izbirnik datuma',
  datePicker_month: () => 'Mesec',
  datePicker_months: () => 'Meseci',
  datePicker_next: () => 'Naslednji',
  datePicker_nextDecade: () => 'Naslednje desetletje',
  datePicker_nextMonth: () => 'Naslednji mesec',
  datePicker_prev: () => 'Prejšnji',
  datePicker_prevDecade: () => 'Prejšnje desetletje',
  datePicker_prevMonth: () => 'Prejšnji mesec',
  datePicker_restricted: () => 'Omejeno',
  datePicker_selected: () => 'Izbrano',
  datePicker_today: () => 'Danes',
  datePicker_weekNum: (p: { NUM: string }) => 'Teden št. ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Številka tedna',
  datePicker_year: () => 'Leto',
  datePicker_years: () => 'Leta',
  diagram_promotedLink: () => 'Št. povezav: 1',
  diagram_promotedLinkAriaDesc: () => 'Posredno',
  diagram_promotedLinks: (p: { num_links: string }) => 'Št. povezav: ' + p['num_links'],
  error: () => 'Napaka',
  expandableList_expandCollapseInstructionText: () =>
    'Za razširitev in strnitev uporabite puščične tipke',
  expandableList_groupCollapse: () => 'Strnjeno',
  expandableList_groupExpand: () => 'Razširjeno',
  filePicker_addFiles: () => 'Dodaj datoteke',
  filePicker_dropzonePrimaryText: () => 'Povlecite in spustite',
  filePicker_dropzoneSecondaryText: () => 'Izberite datoteko ali jo spustite sem',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izberite ali spustite datoteke sem',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne morete nalagati datotek tega tipa: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Naložite po eno datoteko naenkrat',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne morete nalagati datotek tipa ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'neznano',
  formControl_clear: () => 'Počisti',
  formControl_day: () => 'Dan',
  formControl_empty_segment: () => 'Prazno',
  formControl_helpAvailable: () => 'Na voljo je pomoč',
  formControl_hide: () => 'Skrij',
  formControl_hour: () => 'Ura',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dosegli ste omejitev, ki je ' +
    ((
      {
        one: new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znak',
        two: new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znaka',
        few: new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znake'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('sl').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znakov') +
    '.',
  formControl_loading: () => 'Nalaganje',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Vnesete lahko največ toliko znakov: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimalna dolžina, ki je ' + p['MAX_LENGTH'] + ', je presežena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali znaki: ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'Milisekunda',
  formControl_minute: () => 'Minuta',
  formControl_month: () => 'Mesec',
  formControl_readOnly: () => 'Samo za branje',
  formControl_requiredMessageDetail: () => 'Vnesite vrednost.',
  formControl_second: () => 'Sekunda',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Izberite ' + p['n'] + ' vrednosti.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Dosegli ste omejitev izbire, ki je ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Izberite ' + p['min'] + ' do ' + p['max'] + ' vrednosti.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Izberite vsaj ' + p['min'] + ' vrednosti.',
  formControl_show: () => 'Prikaži',
  formControl_year: () => 'Leto',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Konec',
  gantt_labelLabel: () => 'Oznaka',
  gantt_labelRow: () => 'Vrstica',
  gantt_labelStart: () => 'Začetek',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Ni najdenega ujemajočega se odseka.',
  indexer_keyboardInstructionText: () => 'Za izbiro vrednosti pritisnite tipko Enter.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Med ' + p['FROM_SECTION'] + ' in ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvakrat tapnite in zadržite za vstop v način kretenj, nato pa za prilagajanje vrednosti povlecite gor ali dol.',
  info: () => 'Informacije',
  inputColor_selectColor: () => 'Izberite barvo',
  inputDateMask_date_cleared: () => 'Datum čiščenja',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prazno',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'llll',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Vnesite datum, ki je enak ali zgodnejši od ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Vnesite datum, ki je enak ali poznejši od ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Vnesite razpoložljivi datum.',
  inputDatePicker_instruction: () => 'Pritisnite Tab za dostop do koledarja.',
  inputDatePicker_selectDate: () => 'Izberite datum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Vnesite mesec in leto, ki sta enaka ali zgodnejša od ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Vnesite mesec in leto, ki sta enaka ali poznejša od ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Vnesite številko.',
  inputNumber_decrease: () => 'Zmanjšaj',
  inputNumber_increase: () => 'Povečaj',
  inputPassword_hidden: () => 'Geslo je skrito',
  inputPassword_hide: () => 'Skrij geslo',
  inputPassword_show: () => 'Prikaži geslo',
  inputSensitiveText_hidden: () => 'Občutljivo besedilo je skrito',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Vnesite čas, ki je ob ' + p['max'] + ' ali pred tem.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Vnesite čas, ki je ob ' + p['min'] + ' ali pozneje.',
  inputTimeMask_time_cleared: () => 'Čas počiščen',
  labelNone: () => 'Brez',
  list_msgFetchCompleted: () => 'Naloženo',
  list_msgFetchingData: () => 'Nalaganje',
  list_suggestion: () => 'Predlog',
  menu_stateLoading: () => 'Nalaganje',
  messageToast_allMessagesClosed: () => 'Vsa toast obvestila so zaprta.',
  message_close: () => 'Zapri',
  message_confirmation: () => 'Uspeh',
  message_error: () => 'Napaka',
  message_info: () => 'Informacije',
  message_navigationFromMessagesRegion: () =>
    'Vstopanje v področje sporočil. Pritisnite F6 za krmarjenje.',
  message_navigationToMessagesRegion: () =>
    'Področje sporočil ima nova sporočila. Pritisnite F6 za krmarjenje.',
  message_navigationToTouch: () => 'Področje sporočil ima nova sporočila.',
  message_warning: () => 'Opozorilo',
  noData_message: () => 'Ni elementov za prikaz',
  overflowItemLabel: () => 'Več zavihkov',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Dvakrat tapnite, da se odprti pojavni element zapre.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Vstopanje v pojavni element. Pritisnite F6 za krmarjenje med pojavnim elementom in povezano kontrolo.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Pojavni element je odprt. Pritisnite F6 za krmarjenje med pojavnim elementom in povezano kontrolo.',
  progressIndeterminate: () => 'V teku',
  radioButton_checked: () => 'Izbirni gumb označen',
  radioButton_selected: () => 'Izbirni gumb izbran',
  radioButton_unchecked: () => 'Izbirni gumb ni označen',
  radioButton_unselected: () => 'Izbirni gumb ni izbran',
  radio_helpForRadio: () => 'Pomoč za izbirni gumb',
  radio_requiredMessageDetail: () => 'Izberite vrednost.',
  selectMultiple_apply: () => 'Dodeli',
  selectMultiple_back: () => 'Nazaj',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'S puščičnima tipkama levo in desno označite izbrane vrednosti.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Za odstranitev izbrane vrednosti pritisnite tipko Backspace ali Delete.',
  selectMultiple_selectedValues: () => 'Izbrane vrednosti',
  selectMultiple_showSelectedValues: () => 'Prikažite samo izbrane vrednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izbrane vrednosti: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Dodaj na seznam',
  select_addToListAvailable: () => 'Na voljo je dodajanje na seznam',
  select_closeDropdown: () => 'Pritisnite tipko Escape za zapiranje.',
  select_moreSearchOptions: () => 'Več možnosti iskanja',
  select_moreSearchOptionsAvailable: () => 'Na voljo je več možnosti iskanja',
  select_noMatchesFound: () => 'Ni ustreznih zadetkov.',
  select_oneMatchFound: () => 'Najden je en zadetek',
  select_requiredMessageDetail: () => 'Izberite vrednost.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Najdeni zadetki: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Najdeni zadetki: ' + p['TOTAL_SIZE'] + ' ali več',
  selectorAll_deselectAll: () => 'Prekliči izbiro vseh',
  selectorAll_selectAll: () => 'Izbira vseh',
  selector_selected: () => 'Potrditveno polje je označeno',
  selector_unselected: () => 'Potrditveno polje ni označeno',
  sheet_close: () => 'Zapri',
  switch_off: () => 'Izklopljeno',
  switch_on: () => 'Vklopljeno',
  tabBarNavigationList_removeCueText: () => 'Odstranljivo',
  tabBar_tabContainsErrors: () => 'Vsebuje napake',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Odstranjeno: ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'ima priročni meni',
  tabbar_labelMoveLeft: () => 'Premakni levo',
  tabbar_labelMoveRight: () => 'Premakni desno',
  tabbar_labelRemove: () => 'Odstrani',
  timeComponent_tooltipZoomIn: () => 'Povečava',
  timeComponent_tooltipZoomOut: () => 'Pomanjšava',
  timeConverter_parseError: () => 'Vnesite čas dokončanja.',
  train_current: () => 'Trenutno',
  train_message_type: () => 'Tip sporočila',
  train_not_visited: () => 'Ni obiskano',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_visited: () => 'Obiskano',
  userAssistance_learnMore: () => 'Več o tem',
  userAssistance_required: () => 'Zahtevano',
  vis_clearSelection: () => 'Počisti izbiro',
  vis_drillable: () => 'Omogoča vrtanje',
  vis_invalidData: () => 'Neveljavni podatki',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' od ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Izbira potujočega napisa',
  vis_marqueeZoomTooltip: () => 'Povečava potujočega napisa',
  vis_noData: () => 'Ni podatkov za prikaz',
  vis_panTooltip: () => 'Pomikanje',
  vis_stateCollapsed: () => 'Strnjeno',
  vis_stateExpanded: () => 'Razširjeno',
  vis_stateLoaded: () => 'Naloženo',
  vis_stateLoading: () => 'Nalaganje',
  vis_stateSelected: () => 'Izbrano',
  vis_stateUnselected: () => 'Neizbrano',
  warn: () => 'Opozorilo'
};
export default bundle;
